import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  heading: {
    textAlign: "center",
    fontSize: "1.625rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),

    "& > span": {
      color: theme.palette.secondary.main,
    },
  },
}));
